import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import LazyImage from '../lazy-image'
import {
  StyledSectionTitle,
  StyledCastWrapper,
  StyledCastMember,
  StyledCastImage,
  StyledCastName,
  StyledCastCharacter,
  StyledShowMoreButton,
  StyledCastEpisodeCount,
} from './details-page-styles'

type CastMember = {
  id: number
  name: string
  character?: string
  imageUrl?: string
  episodeCount?: number
}

type CastSectionProps = {
  cast: CastMember[]
  title?: string
  initialVisibleCount?: number
}

const CastSection = ({
  cast,
  title = 'Cast',
  initialVisibleCount = 10,
}: CastSectionProps) => {
  const [showAll, setShowAll] = useState(false)

  const sortedCast = [...cast].sort(
    (a, b) => (b.episodeCount ?? 0) - (a.episodeCount ?? 0),
  )

  const displayed = showAll
    ? sortedCast
    : sortedCast.slice(0, initialVisibleCount)

  return (
    <>
      <StyledSectionTitle>{title}</StyledSectionTitle>
      {showAll && cast.length > initialVisibleCount && (
        <StyledShowMoreButton
          onClick={() => setShowAll(!showAll)}
          endIcon={<ExpandLessIcon />}
        >
          Show Less
        </StyledShowMoreButton>
      )}
      <StyledCastWrapper>
        {displayed.map((member) => (
          <StyledCastMember
            key={member.id}
            component={RouterLink}
            to={`/actors/${member.id}`}
          >
            <StyledCastImage>
              <LazyImage
                src={member.imageUrl}
                alt={member.name}
                fallback={member.name.slice(0, 1).toUpperCase() || '?'}
              />
            </StyledCastImage>
            <StyledCastName>{member.name}</StyledCastName>
            <StyledCastCharacter>{member.character}</StyledCastCharacter>
            {member.episodeCount && (
              <StyledCastEpisodeCount>{`${member.episodeCount} episode${member.episodeCount === 1 ? '' : 's'}`}</StyledCastEpisodeCount>
            )}
          </StyledCastMember>
        ))}
      </StyledCastWrapper>
      {cast.length > initialVisibleCount && (
        <StyledShowMoreButton
          onClick={() => setShowAll(!showAll)}
          endIcon={showAll ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        >
          {showAll ? 'Show Less' : `Show All (${cast.length})`}
        </StyledShowMoreButton>
      )}
    </>
  )
}

export default CastSection
